import { Inject, Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivateChild } from '@angular/router';

import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { AuthService } from '../api/auth.api';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(public router: Router, private authService: AuthService) {}

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {

    return this.authService.user.pipe(
      take(1),
      map(user => {
        const isAuth = !!user;
        if(isAuth) {
          return true;
        }
        return this.router.createUrlTree(['auth/login']);
      })
    );

  }

  canActivate(route: ActivatedRouteSnapshot, router: RouterStateSnapshot):
    Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree
  {
    return this.authService.user.pipe(
      take(1),
      map(user => {
        const isAuth = !!user;
        if(isAuth) {
          return true;
        }
        return this.router.createUrlTree(['auth/login']);
      })
    );
  }
}

@Injectable({ providedIn: 'root' })
export class IsLoggedIn implements CanActivate {

  environment: any;
  dashboardLink: any;
  version: any;

  constructor(
    @Inject('AppEnvironment') environmentConfig,
    public router: Router, private authService: AuthService) {
      this.environment = environmentConfig;

      this.version = (this.environment.apiVersion ? this.environment.apiVersion + '/' : '');
    }

  canActivate(route: ActivatedRouteSnapshot, router: RouterStateSnapshot):
  Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree{
    return this.authService.user.pipe(
      take(1),
      map(user => {
        const isAuth = !!user;
        if(!isAuth) {
          return true;
        }

        this.dashboardLink = this.version;

        if(this.environment.appName == 'super-admin'){
          this.dashboardLink = this.version+'main';
        }

        if(this.environment.appName == 'school'){
          this.dashboardLink = this.version+'teleconsult';
        }

        if(this.environment.appName == 'student'){
          this.dashboardLink = this.version+'teleconsult';
        }

        if(this.environment.appName == 'staff'){
          this.dashboardLink = this.version+'teleconsult';
        }

        if(this.environment.appName == 'provider'){
          this.dashboardLink = this.version+'teleconsult';
        }

        if(this.environment.appName == 'client'){
          // this.dashboardLink = this.version+'teleconsult';
          this.dashboardLink = 'forms';
        }
        // if(this.environment.appName == 'client'){
        //   this.dashboardLink = this.version+'admin';
        // }

        if(this.environment.appName == 'hospitality' || this.environment.appName ==  'hospitality-group'){
          this.dashboardLink = this.version+'teleconsult';
        }

        if(this.environment.appName == 'scancentre'){
          this.dashboardLink = this.version+'scans';
        }

        return this.router.createUrlTree([this.dashboardLink]);
      })
    );
  }
}
